<template>
	<div class="ai_container" ref="pdfContent">
		<div class="header_container">
			<div style="width: 24px" />
			<div class="heading_7">견적서</div>
			<div style="width: 24px" />
		</div>
		<div class="estimate_overview_wrapper">
			<div>
				<b class="heading_6">{{ estimateNo }}</b>
				<p class="body_8 f_gray_4">{{ estimateDate }} 기준</p>
			</div>
		</div>
		<div class="estimate_car_info_wrapper">
			<div class="title_wrapper heading_7">
				차량 정보
				<img
					:class="`${true ? '' : 'car_info_close'}`"
					src="/static/icons/arrow/arrow_small_bold_up.svg"
					alt="arrow" />
			</div>
			<ul>
				<li v-for="item in carInfo" :key="item.label">
					<p class="body_8 f_gray_4">{{ item.label }}</p>
					<b class="body_7_M">
						{{ item.value }}
						<span v-if="!!item.subValue" class="body_10_M f_gray_4">{{
							item.subValue
						}}</span>
					</b>
				</li>
			</ul>
		</div>
		<div class="estimate_price_info_wrapper">
			<Tab
				:options="[
					{ label: '제휴협력공장', value: 'am' },
				]"
				:activeKey="'am'"
			/>
			<div class="title_wrapper heading_7">
				견적 내역 <span class="body_10">(딜러가 대비 <span class="body_10" style="color:#295BFF">{{diffPrice.toLocaleString()}}</span>원 저렴)</span>
			</div>
			<div class="estimate_price_list_wrapper">
				<ul>
					<li v-for="item in setPriceList()" :key="item.label">
						<p class="body_8 f_gray_4">{{ item.label }}</p>
						<b :class="`${item.discount ? 'body_7 f_red_1' : 'heading_8'}`">{{ item.discount ? "-" : ""
							}}{{ item.value.toLocaleString() }}원</b>
					</li>
				</ul>
				<div>
					<b class="heading_7">최종 견적</b>
					<b class="heading_7"> {{ setTotalPriceList() }}원 </b>
				</div>
			</div>
		</div>

		<div class="estimate_detail_wrapper">
			<!-- <Segmented
				:options="[
					{ label: '부품', value: 'part' },
					{ label: '공임', value: 'repair' },
					{ label: '도장', value: 'paint' },
				]"
				:activeKey="'part'"
			/> -->

			<div class="segmented_container">
				<div class="segmented_wrapper">
					<div class="segmented_item heading_7 ">
						부품
					</div>
				</div>
			</div>
			<ul>
				<li v-for="item in partList" :key="item.partNo">
					<div class="left-section">
						<div class="part_label body_11_M f_green_1">{{item.type}}</div>
					</div>
					<div class="main-section">
						<div class="content-section">
							<p v-html="item.name.replace(/\n/g, '<br>')" class="heading_8"></p>
							<p v-if="!!item.price && item.price > 0" class="body_11 f_gray_3">단가 {{
								item.price.toLocaleString() }}원</p>
							<p v-if="!!item.amount && item.amount > 0" class="body_11 f_gray_3">수량 {{
								item.amount.toLocaleString() }}개</p>
						</div>
						<div class="price-section">
							<p class="heading_8 f_green_1">{{ (item.totalPrice).toLocaleString() }}원</p>
						</div>
					</div>
				</li>
			</ul>
			<!-- <Segmented
				:options="[
					{ label: '부품', value: 'part' },
					{ label: '공임', value: 'repair' },
					{ label: '도장', value: 'paint' },
				]"
				:activeKey="'repair'"
			/> -->
			<div class="segmented_container">
				<div class="segmented_wrapper">
					<div class="segmented_item heading_7 ">
						공임
					</div>
				</div>
			</div>
			<ul>
				<li v-for="item in repairList" :key="item.partNo">
					<div class="left-section">
						<div class="part_label body_11_M f_green_1">{{item.type}}</div>
					</div>
					<div class="main-section">
						<div class="content-section">
							<p v-html="item.name.replace(/\n/g, '<br>')" class="heading_8"></p>
							<p v-if="!!item.price && item.price > 0" class="body_11 f_gray_3">단가 {{
								item.price.toLocaleString() }}원</p>
							<p v-if="!!item.amount && item.amount > 0" class="body_11 f_gray_3">수량 {{
								item.amount.toLocaleString() }}개</p>
						</div>
						<div class="price-section">
							<p class="heading_8 f_green_1">{{ (item.totalPrice).toLocaleString() }}원</p>
						</div>
					</div>
				</li>
			</ul>
			<!-- <Segmented
				:options="[
					{ label: '부품', value: 'part' },
					{ label: '공임', value: 'repair' },
					{ label: '도장', value: 'paint' },
				]"
				:activeKey="'paint'"
			/> -->
			<div class="segmented_container">
				<div class="segmented_wrapper">
					<div class="segmented_item heading_7 ">
					부품
					</div>
				</div>
			</div>
			<ul>
				<li v-for="item in paintList" :key="item.partNo">
					<div class="left-section">
						<div class="body_11_M "></div>
					</div>
					<div class="main-section">
						<div class="content-section">
							<p v-html="item.name.replace(/\n/g, '<br>')" class="heading_8"></p>
							<p v-if="!!item.price && item.price > 0" class="body_11 f_gray_3">단가 {{
								item.price.toLocaleString() }}원</p>
							<p v-if="!!item.amount && item.amount > 0" class="body_11 f_gray_3">수량 {{
								item.amount.toLocaleString() }}개</p>
						</div>
						<div class="price-section">
							<p class="heading_8 f_green_1">{{ (item.totalPrice).toLocaleString() }}원</p>
						</div>
					</div>
				</li>
			</ul>
		</div>
		<div class="estimate_photo_wrapper">
			<div class="title_wrapper heading_7">
				수리 부위 사진
			</div>
			<ul>
				<li v-for="image in imageList" :key="image.id" @click="() => handleImageClick(image.id)">
					<img :src="image.src" />
				</li>
			</ul>
		</div>
		<div class="estimate_bottom_wrapper body_9">
			• 견적 전송일자에 따라 가격이 변동될 수 있어요.
		</div>
		<div class="loading-wrapper" v-if="isDownloading">
			<p>PDF 다운로드 중...</p>
		</div>

	</div>

</template>

<script>
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import Tab from '../../components/ai/AiTab.vue'
import Segmented from '../../components/ai/AiSegmented.vue'

export default {
	name: 'AiPdf',
	props: {
		estimateNo: String,
		estimateDate: String,
		totalNetCorrected: Number,
		carInfo: Array,
		priceInfo: Array,
		partList: Array,
		repairList: Array,
		paintList: Array,
		diffPrice: Number,
		imageList: Array
	},
	components: {
		Segmented,
		Tab,

	},
	data() {
		return {
			isDownloading: false,  // 다운로드 중 표시 여부
		};
	},
	mounted() {
		this.downloadPdf();
	},
	methods: {
		setPriceList() {
			return this.priceInfo;
		},
		setTotalPriceList() {
			return this.totalNetCorrected.toLocaleString();
		},

		downloadPdf() {
			this.isDownloading = true;  // 다운로드 시작 시 로딩 표시
			this.$nextTick(() => {
				const pdfContent = this.$refs.pdfContent;
				html2canvas(pdfContent).then(canvas => {
					const imgData = canvas.toDataURL("image/jpeg");
					const pdf = new jsPDF({
						orientation: "portrait",
						unit: "mm",
						format: [canvas.width * 0.264583, canvas.height * 0.264583]
					});

					pdf.addImage(imgData, "jpeg", 0, 0, canvas.width * 0.264583, canvas.height * 0.264583);
					pdf.save(`${this.estimateNo}_견적서.pdf`);

					this.isDownloading = false;  // 다운로드 완료 후 로딩 표시 제거
					this.$emit('downloadComplete');  // 다운로드 완료 이벤트 발생
				});
			});
		}
	}
}
</script>

<style scoped>
.pdf-container {
	position: relative;
}
.loading-wrapper {
	position: fixed;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	background: rgba(0, 0, 0, 0.5);
	padding: 20px;
	border-radius: 10px;
	color: white;
}

.segmented_container {
  padding:8px 20px;
  position: relative;
}

.segmented_wrapper {
  display: flex;
  background-color: var(--gray-scale-10);
  border-radius: 8px;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 8px;
}

.segmented_wrapper > .segmented_item {
  width: 100%;
  text-align: center;
  z-index: 1;
color:black
}

.segmented_indicator {
  position: absolute;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.06);
  border-radius: 8px;
  text-align: center;
  transition: 0.3s;
  color: transparent;
  background-color: var(--gray-scale-12);
  height: 24px;
  top:50%;
}
</style>



// WEBPACK FOOTER //
// src/components/ai/AiPdf.vue